import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "name", "component", "element"];
import React from 'react';
import Typography from "@mui/material/Typography";
import PropTypes from 'prop-types';

var PlainText = function PlainText(_ref) {
  var label = _ref.label,
      name = _ref.name,
      component = _ref.component,
      element = _ref.element,
      props = _objectWithoutProperties(_ref, _excluded);

  return typeof label === 'string' ? label.split('\n').map(function (paragraph, index) {
    return /*#__PURE__*/React.createElement(Typography, _extends({
      key: "".concat(index, "-").concat(name)
    }, props, element && {
      component: element
    }), paragraph);
  }) : /*#__PURE__*/React.createElement(Typography, _extends({}, props, element && {
    component: element
  }), label);
};

PlainText.propTypes = {
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  component: PropTypes.any,
  element: PropTypes.elementType
};
PlainText.defaultProps = {
  variant: 'body1',
  gutterBottom: true
};
export default PlainText;